import {
  Alert,
  AlertProps,
  AlertTitle,
  Theme,
  Typography,
} from '@mui/material';
import { FC } from 'react';
import { MaintenanceInfo } from '../maintenance-types';
import { makeStyles } from 'tss-react/mui';
import { format } from 'date-fns';

const MaintenanceBanner: FC<MaintenanceBannerProps> = ({ info, ...props }) => {
  const { classes } = useStyles();
  const { start, end, reason } = info;

  return (
    <Alert severity='info' className={classes.maintenanceBanner} {...props}>
      <AlertTitle>Maintenance Notice</AlertTitle>
      <Typography color='text.primary' variant='body1'>
        Maintenance scheduled to start on&nbsp;
        <b>
          {format(new Date(start), 'EEEE')} ({start.toLocaleString()})
        </b>
        &nbsp;and end on&nbsp;
        <b>
          {format(new Date(end), 'EEEE')} ({end.toLocaleString()})
        </b>
        <br />
        {reason}
      </Typography>
    </Alert>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  maintenanceBanner: {
    '& b': {
      fontWeight: 600,
    },
  },
}));

export interface MaintenanceBannerProps extends AlertProps {
  info: MaintenanceInfo;
}
export default MaintenanceBanner;
